import { SoccerGoalSvg } from "../components/sports/SoccerGoalSvg.tsx";
import { useI18n } from "../i18n/context.tsx";
import styles from "./ComingSoon.module.css";
import { ComingSoonTemplate } from "./ComingSoonTemplate.tsx";

export function SoccerAiPage() {
  const { t } = useI18n();
  return (
    <ComingSoonTemplate
      sport={t.soccer}
      variant="ai"
      badgeClass={styles.badgeSoccer}
      svgPreview={<SoccerGoalSvg />}
      seoTitle="ShootCreator Soccer AI - Coming Soon"
      seoDesc="AI-powered soccer shot analysis with goal zone biometrics and voice transcription. Coming soon."
      canonicalPath="/soccer/ai"
    />
  );
}
